import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchCreateHackathon,
  fetchGetAllHackathons,
  fetchGetHackathonById,
} from "../api/hackathonAPI";
import { clearError, setError } from "./uiSlice";

export const getAllHackathons = createAsyncThunk(
  "hackathon/getAllHackathons",
  async (type = null, { rejectWithValue, dispatch }) => {
    try {
      const result = await fetchGetAllHackathons();
      if (!result.success) {
        dispatch(
          setError(result.message || "Failed to get hackathons details")
        );
        return rejectWithValue(result.message);
      }
      dispatch(clearError());
      return result.hackathons;
    } catch (err) {
      dispatch(setError("Failed to get hackathons details."));
      return rejectWithValue(err.message);
    }
  }
);

export const createHackathon = createAsyncThunk(
  "hackathon/createHackathon",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const result = await fetchCreateHackathon(payload);
      return result;
    } catch (err) {
      dispatch(setError("Failed to create hackathon."));
      return rejectWithValue(err.message);
    }
  }
);

export const getHackathonById = createAsyncThunk(
  "hackathon/getHackathonById",
  async (hackathonId, { rejectWithValue, dispatch }) => {
    try {
      const result = await fetchGetHackathonById(hackathonId);
      if (!result.success) {
        dispatch(setError(result.message || "Failed to get hackathon details"));
        return rejectWithValue(result.message);
      }
      return result.data;
    } catch (err) {
      dispatch(setError("Failed to get hackathon details."));
      return rejectWithValue(err.message);
    }
  }
);

const hackathonSlice = createSlice({
  name: "hackathon",
  initialState: {
    hackathons: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearHackathonError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllHackathons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllHackathons.fulfilled, (state, action) => {
        state.loading = false;
        state.hackathons = action.payload;
      })
      .addCase(getAllHackathons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createHackathon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createHackathon.fulfilled, (state, action) => {
        state.loading = false;
        state.hackathons.push(action.payload.data);
      })
      .addCase(createHackathon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to create job";
      })
      .addCase(getHackathonById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHackathonById.fulfilled, (state, action) => {
        state.loading = false;
        state.hackathons = action.payload;
      })
      .addCase(getHackathonById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearHackathonError } = hackathonSlice.actions;

export default hackathonSlice.reducer;
